export default "__VITE_ASSET__a4e0e2c6__"